export default "__VITE_ASSET__GwPkhuPd__"